export const SET_PROJECTS_FOLDER_DELETE_DIALOG_IS_OPEN = 'SET_PROJECTS_FOLDER_DELETE_DIALOG_IS_OPEN'
export const SET_PROJECTS_FOLDER_DELETE_PENDING = 'SET_PROJECTS_FOLDER_DELETE_PENDING'
export const SET_PROJECTS_FOLDER_TO_DELETE = 'SET_PROJECTS_FOLDER_TO_DELETE'
